import React from 'react';
import { Box, Image, Text } from '@betty/moonlight';

import { WhyBetty } from './WhyBettySection.constants';
import styles from './WhyBettySection.module.css';

function WhyBettySection() {
  return (
    <div className={styles.whyBettySection}>
      <Text variant="h4" gradient="darkSurfaceAccent" marginBottom="space-400">
        Why play Betty?
      </Text>
      <div className={styles.boxContainer}>
        {WhyBetty.map((card) => (
          <Box
            gap="space-400"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            backgroundColor='primaryBackground'
            borderRadius="radius-400"
            padding='space-400'
            height={{
              desktop: 240,
              tablet: 240,
              mobile: undefined,
            }}
            key={card.title}
          >
            <Image
              name={card.imgSrc}
              width={{
                desktop: 108,
                tablet: 108,
                mobile: 60,
              }}
              height={{
                desktop: 108,
                tablet: 108,
                mobile: 60,
              }}
            />
            <Text variant="h6" color="darkSurfacePrimary" textAlign="center">
              {card.title}
            </Text>
          </Box>
        ))}
      </div>
    </div>
  );
}

export default WhyBettySection;
